'use client'
import '@dynamic-labs/sdk-api-core';
import '../../../logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import { isSSR } from '../../functions/isSSR/isSSR.js';
import '@dynamic-labs/utils';
import '../../../../utils/constants/colors.js';
import '../../../../utils/constants/values.js';

/**
 * Prefetches a resource
 * Adds a link element to the head of the document with the provided attributes
 * when the element is not already present
 * @param {PrefetchProps} prefetchProps
 * @returns {void}
 *
 * @example
 * usePrefetch({
 *  href: 'https://example.com/image.jpg',
 *  as: 'image',
 *  type: 'image/jpeg',
 *  id: 'image-prefetch',
 * });
 */
const usePrefetch = ({ as, href, id, type }) => {
    // Do not run on server side
    if (isSSR())
        return;
    const predefinedElement = document.head.querySelector(`#${id}`);
    // Do not add the element if it already exists
    if (predefinedElement)
        return;
    const element = document.createElement('link');
    element.setAttribute('id', id);
    element.setAttribute('rel', 'prefetch');
    element.setAttribute('href', href);
    element.setAttribute('as', as);
    element.setAttribute('type', type);
    document.head.insertAdjacentElement('beforeend', element);
};

export { usePrefetch };
